import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, Mail } from 'lucide-react';
import { toast } from 'sonner';
import { useStore } from '@/context/StoreContext';
import { isAdminRole } from '@/lib/permissions';

export default function AdminLogin() {
  const { login } = useStore();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email, password);
      if (!isAdminRole(u)) { toast.error('Not an admin account'); return; }
      navigate('/admin');
    } catch (err) { toast.error(err?.response?.data?.detail || 'Login failed'); }
    finally { setBusy(false); }
  };
  const field = 'w-full rounded-lg border border-border bg-white py-2.5 pl-10 pr-3 text-sm outline-none focus:border-[hsl(var(--gaze-gold))]';
  return (
    <div className="grid min-h-screen place-items-center bg-[hsl(var(--primary))] p-4">
      <div className="w-full max-w-sm rounded-3xl bg-white p-8">
        <div className="text-center"><span className="font-display text-3xl">Gaze</span><span className="ml-1 text-sm gaze-gold">Admin</span><p className="mt-1 text-sm text-muted-foreground">Sign in to manage your store</p></div>
        <form onSubmit={submit} className="mt-6 space-y-3">
          <div className="relative"><Mail size={16} className="absolute left-3 top-3 text-muted-foreground" /><input value={email} onChange={(e) => setEmail(e.target.value)} className={field} placeholder="Email" data-testid="admin-email" /></div>
          <div className="relative"><Lock size={16} className="absolute left-3 top-3 text-muted-foreground" /><input value={password} onChange={(e) => setPassword(e.target.value)} type="password" className={field} placeholder="Password" data-testid="admin-password" /></div>
          <button type="submit" disabled={busy} data-testid="admin-login-submit" className="w-full rounded-full bg-[hsl(var(--primary))] py-3 text-sm font-semibold text-white disabled:opacity-60">{busy ? 'Signing in...' : 'Login'}</button>
        </form>
        <p className="mt-4 text-center text-xs text-muted-foreground"></p>
      </div>
    </div>
  );
}
